<div
  [class.-translate-y-full]="hideNavbar"
  class="z-[100] px-10 flex-col justify-center items-center w-full h-auto flex fixed top-0 transition-transform duration-300"
>
  <div
    class="mt-8 mx-auto w-full md:w-fit backdrop-blur-[30px] bg-[#231f2080] border border-[#ffffff40] rounded-[16px] justify-between items-center h-[3.75rem] flex shadow-[0_20px_40px_#ffffff0d] pl-4 gap-5"
  >
    <!-- Logo -->
    <a href="https://www.wellext.de" class="flex items-center">
      <img class="object-contain w-32 mb-0" loading="eager" src="/images/logo_text.svg" alt="Logo" />
    </a>

    <!-- Burger Button -->
    <button
      (click)="menuOpen = !menuOpen"
      class="mr-4 md:hidden flex items-center justify-center text-white focus:outline-none"
    >
      @if (!menuOpen) {
        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      } @else {
        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      }
    </button>

    <!-- Desktop Navigation -->
    <nav class="hidden md:flex md:items-center">
      <ul class="flex items-center">
        <li>
          <a href="https://www.wellext.de/angebot"
            class="whitespace-nowrap px-[19px] py-[16px] hover:bg-black/33 rounded-[16px] text-[#f4f4f4] tracking-tighter font-medium cursor-pointer no-underline transition-all duration-200"
            >Deine wellbase</a
          >
        </li>
        <li>
          <a href="https://www.wellext.de/preise"
            class="whitespace-nowrap px-[19px] py-[16px] hover:bg-black/33 rounded-[16px] text-[#f4f4f4] tracking-tighter font-medium cursor-pointer no-underline transition-all duration-200"
            >Preise</a
          >
        </li>
        <li>
          <a href="https://www.wellext.de/gutscheine"
            class="whitespace-nowrap px-[19px] py-[16px] hover:bg-black/33 rounded-[16px] text-[#f4f4f4] tracking-tighter font-medium cursor-pointer no-underline transition-all duration-200"
            >Gutscheine</a
          >
        </li>
        <li>
          <a href="https://www.wellext.de/faq"
            class="whitespace-nowrap px-[19px] py-[16px] hover:bg-black/33 rounded-[16px] text-[#f4f4f4] tracking-tighter font-medium cursor-pointer no-underline transition-all duration-200"
            >FAQ</a
          >
        </li>
        <li>
          <a href="https://www.wellext.de/about"
            class="whitespace-nowrap px-[19px] py-[16px] hover:bg-black/33 rounded-[16px] text-[#f4f4f4] tracking-tighter font-medium cursor-pointer no-underline transition-all duration-200"
            >Über uns</a
          >
        </li>
      </ul>
    </nav>
    <div class="hidden md:block">
      @if (lockInfo.value?.order) {
        <p-button
          [routerLink]="['/order', lockInfo.value?.order?.locationId]"
          [queryParams]="{ secret: lockInfo.value?.order?.orderSecret, orderNumber: lockInfo.value?.order?.orderCode }"
          size="large"
          styleClass="mr-2"
          ><i class="pi pi-shopping-cart"></i
        ></p-button>
      } @else if (lockInfo.value?.session) {
        <p-button
          [routerLink]="['/booking', lockInfo.value?.session?.locationId]"
          [queryParams]="{ sessionId: lockInfo.value?.session?.sessionId }"
          size="large"
          styleClass="mr-2"
          ><i class="pi pi-shopping-cart"></i
        ></p-button>
      } @else {
        <p-button routerLink="/session" size="large" styleClass="whitespace-nowrap mr-2">wellbase buchen</p-button>
      }
    </div>
  </div>

  @if (menuOpen) {
    <div class="md:hidden w-full mt-2 backdrop-blur-[30px] rounded-[16px]">
      <ul class="flex flex-col bg-[#231f2080] border border-[#ffffff40] rounded-xl p-4">
        <li>
          <a href="https://www.wellext.de/angebot"
            class="whitespace-nowrap block w-full px-[15px] py-[8px] hover:bg-black/33 rounded-[9px] text-[#f4f4f4] tracking-tighter font-medium cursor-pointer no-underline transition-all duration-200"
            >Deine wellbase</a
          >
        </li>
        <li>
          <a href="https://www.wellext.de/preise"
            class="whitespace-nowrap block w-full px-[15px] py-[8px] hover:bg-black/33 rounded-[9px] text-[#f4f4f4] tracking-tighter font-medium cursor-pointer no-underline transition-all duration-200"
            >Preise</a
          >
        </li>
        <li>
          <a href="https://www.wellext.de/gutscheine"
            class="whitespace-nowrap block w-full px-[15px] py-[8px] hover:bg-black/33 rounded-[9px] text-[#f4f4f4] tracking-tighter font-medium cursor-pointer no-underline transition-all duration-200"
            >Gutscheine</a
          >
        </li>
        <li>
          <a href="https://www.wellext.de/faq"
            class="whitespace-nowrap block w-full px-[15px] py-[8px] hover:bg-black/33 rounded-[9px] text-[#f4f4f4] tracking-tighter font-medium cursor-pointer no-underline transition-all duration-200"
            >FAQ</a
          >
        </li>
        <li>
          <a href="https://www.wellext.de/about"
            class="whitespace-nowrap block w-full px-[15px] py-[8px] hover:bg-black/33 rounded-[9px] text-[#f4f4f4] tracking-tighter font-medium cursor-pointer no-underline transition-all duration-200"
            >Über uns</a
          >
        </li>
        <li class="whitespace-nowrap block relative pt-4">
          @if (lockInfo.value?.order) {
            <p-button
              [routerLink]="['/order', lockInfo.value?.order?.locationId]"
              [queryParams]="{ secret: lockInfo.value?.order?.orderSecret, orderNumber: lockInfo.value?.order?.orderCode }"
              fluid
              size="large"
              ><i class="pi pi-shopping-cart"></i
            ></p-button>
          } @else if (lockInfo.value?.session) {
            <p-button
              [routerLink]="['/booking', lockInfo.value?.session?.locationId]"
              [queryParams]="{sessionId: lockInfo.value?.session?.sessionId}"
              size="large"
              fluid
              ><i class="pi pi-shopping-cart"></i
            ></p-button>
          } @else {
            <p-button routerLink="/session" size="large" styleClass="mr-2">wellbase buchen</p-button>
          }
        </li>
      </ul>
    </div>
  }
</div>
